import React, { useState, useEffect, useImperativeHandle, useRef } from 'react';
import { Icon, Collapse } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';

import { getDefaultTree, checkGroupLowLimit } from '../utils';

import { ActTypeObj } from '@/utils';

import AddOfferGroup from '../AddOfferGroup';

import ExpandeForm from './ExpandeForm';

import styles from '../index.module.less';

const GoodsAttr = props => {
  const { modelKey, offerGroupArr = [], refInstance } = props;
  const [goodsTree, setGoodsTree] = useState([]);
  const [activeGoodsPanels, setActiveGoodsPanels] = useState([]);

  const expandeRef = useRef();

  useEffect(() => {
    if (!isEmpty(offerGroupArr)) {
      const defaultTree = getDefaultTree(offerGroupArr);
      setGoodsTree(defaultTree);
    }
  }, [offerGroupArr]);

  useImperativeHandle(refInstance, () => ({
    getGoodsInfo: async () => {
      await checkGroupLowLimit(goodsTree, 'GOODS_LOWER');
      if (expandeRef.current) {
        await expandeRef.current.validateFields();
      }
      let result = [];
      goodsTree.forEach(it => {
        if (!isEmpty(it.children)) {
          let res = [];
          if (modelKey === 'newConnection') {
            res = it.children.map(child => ({
              resId: child.offerId,
              resCode: get(child, 'offerDto.offerCode'),
              resName: child.offerName,
              actType: ActTypeObj.ADD,
              attrValueList: child.attrValueList,
            }));
          } else {
            res = it.children.map(child => ({
              offerId: child.offerId,
              offerCode: get(child, 'offerDto.offerCode'),
              operationType: ActTypeObj.ADD,
              goodsAttrDtoList: child.attrValueList,
            }));
          }
          result = [...result, ...res];
        }
      });
      return result;
    },
  }));

  const handleAdd = selectedInfo => setGoodsTree(selectedInfo);

  const handleDelete = (e, fatherIndex, childIndex) => {
    e.stopPropagation();
    const cloneArr = cloneDeep(goodsTree);
    const curOfferGroup = cloneArr[fatherIndex];
    const children = (curOfferGroup.children || []).filter((it, i) => i !== childIndex);
    cloneArr[fatherIndex] = {
      ...curOfferGroup,
      children,
    };
    setGoodsTree([...cloneArr]);
  };

  const handleAcqChange = (changeValue, fatherIndex, childIndex) => { // 设备信息采集表单change
    const cloneArr = cloneDeep(goodsTree);
    const children = get(cloneArr[fatherIndex], 'children') || [];
    const curChild = children[childIndex] || {};
    let attrValueList = curChild.attrValueList || [];
    const changeAttrCode = Object.keys(changeValue)[0];
    let hasAttr = false; // 判断 attrValueList 里面有没有当前的 changeValue 的值
    attrValueList = attrValueList.map(attr => {
      if (attr.attrCode === changeAttrCode) {
        hasAttr = true;
        return {
          ...attr,
          attrValue: changeValue[changeAttrCode],
          value: changeValue[changeAttrCode],
        };
      }
      return attr;
    });
    if (!hasAttr) {
      // 之前没有这个数据，
      attrValueList.push({
        attrCode: changeAttrCode,
        attrValue: changeValue[changeAttrCode],
        value: changeValue[changeAttrCode],
      });
    }
    curChild.attrValueList = attrValueList;
    children[childIndex] = curChild;
    cloneArr[fatherIndex].children = children;
    setGoodsTree(cloneArr);
  };

  const renderExpandIcon = res => {
    const { isActive } = res;
    return (
      <Icon type={isActive ? 'caret-down' : 'caret-up'} />
    );
  };

  const expandedRowRender = (fatherIndex, record, index, tabKey) => {
    const { attrValueList } = record;
    const initialValue = {};
    (attrValueList || []).forEach(it => {
      initialValue[it.attrCode] = it.attrValue;
    });
    return (
      <ExpandeForm
        ref={expandeRef}
        modelKey={modelKey}
        initialValue={initialValue}
        tabKey={tabKey}
        onChange={value => handleAcqChange(value, fatherIndex, index)}
        activeGoodsPanels={activeGoodsPanels}
        onCollapseChange={onCollapseChange}
      />);
  };

  const renderDeleteEventBtn = (fatherIndex, childIndex, child) => {
    if (child.isNecessary) {
      return '';
    }
    return (
      <div className={styles.btnsBox} onClick={e => handleDelete(e, fatherIndex, childIndex)}>
        <Icon type="delete" />
      </div>
    );
  };

  const onCollapseChange = (keys) => {
    setActiveGoodsPanels(keys);
  };

  return (
    <div className={`blockWrap ${styles.offerGroupDiv}`}>
      <div className={styles.header}>
        <h3 className="blockTitle">{i18n('SELECT_GOODS')}</h3>
        <AddOfferGroup offerGroupArr={offerGroupArr} onSubmit={handleAdd} selectedTree={goodsTree} title={i18n('SELECT_GOODS')} />
      </div>
      {
        (goodsTree || []).map((it, fatherIndex) => {
          if (!isEmpty(it.children)) {
            return (
              <div key={`${it.offerGroupCode}_${fatherIndex}`} className={styles.offerInfo}>
                <h4 className="blockSubTitle">{`${it.offerGroupName} [${it.lowLimit || 0} - ${it.upperLimit || 'N'}]`}</h4>
                <Collapse renderExpandIcon={renderExpandIcon} activeKey={activeGoodsPanels} onChange={onCollapseChange} >
                  {
                    (it.children || []).map((child, childIndex) => (
                      <Collapse.Panel
                        header={get(child, 'offerDto.offerName')}
                        key={`${child.offerId}_${childIndex}`}
                        extra={renderDeleteEventBtn(fatherIndex, childIndex, child)}
                        forceRender={true}
                      >
                        {expandedRowRender(fatherIndex, child, childIndex, `${child.offerId}_${childIndex}`)}
                      </Collapse.Panel>
                    ))
                  }
                </Collapse>
              </div>
            );
          }
          return '';
        })
      }
    </div>
  );
};

export default React.forwardRef((props, ref) => <GoodsAttr {...props} refInstance={ref} />);
